/**
 * Handles server-side errors by populating the error state for individual form fields.
 *
 * This function takes a dictionary of errors and a function to set errors for specific fields.
 * It iterates through the error dictionary and sets corresponding error messages for each field.
 *
 * @template T - The type representing the form fields.
 * @param errors - A dictionary of errors where the keys represent field names, and values are arrays of error messages.
 * @param setError - A function that sets errors for a specific field.
 */
export function addServerErrors<T>(errors: { [P in keyof T]?: string[] }, setError: (fieldName: keyof T, error: { type: string; message: string }) => void) {
    Object.keys(errors).forEach((key) => {
        setError(key as keyof T, {
            type: 'server',
            message: errors[key as keyof T]!.join('. '),
        });
    });
}
